import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {RedirectResolver} from './core/resolvers/redirect.resolver';
import {BanksResolver} from './core/resolvers/banks.resolver';
import {ErrorResolver} from './core/resolvers/error.resolver';
import {AccountsResolver} from './core/resolvers/accounts.resolver';
import {TransactionResolver} from "./core/resolvers/transaction.resolver";
import {PrepareResolver} from "./core/resolvers/prepare.resolver";
import {checkIfFlowIdIsStoredGuard} from "./core/check-if-flow-id-is-stored.guard";
import {deactivateGuard} from "./core/disable-back.guard";
import {checkIfFlowIdExistInUrlGuard} from "./core/check-if-flow-id-exist-in-url.guard";


const ROUTES: Routes = [
  {
    path: ':language/start',
    loadChildren: () => import('./modules/redirect-info-continue/redirect-info-continue.module').then(m => m.RedirectInfoContinueModule),
    canLoad: [checkIfFlowIdExistInUrlGuard(), checkIfFlowIdIsStoredGuard()],
    canActivate: [checkIfFlowIdExistInUrlGuard(), checkIfFlowIdIsStoredGuard()],
    resolve: {PrepareResolver}
  },
  {
    path: 'continue',
    loadChildren: () => import('./modules/redirect-info-continue/redirect-info-continue.module').then(m => m.RedirectInfoContinueModule),
    canLoad: [checkIfFlowIdExistInUrlGuard(), checkIfFlowIdIsStoredGuard()],
    canActivate: [checkIfFlowIdExistInUrlGuard(), checkIfFlowIdIsStoredGuard()],
    resolve: {RedirectResolver}
  },
  {
    path: 'payment-provider-selection',
    loadChildren: () => import('./modules/bank-selection/bank-selection.module').then(m => m.BankSelectionModule),
    resolve: {BanksResolver},
    canLoad: [checkIfFlowIdIsStoredGuard()],
    canActivate: [checkIfFlowIdIsStoredGuard()],
    canDeactivate: [deactivateGuard()]
  },
  {
    path: 'bank-auth-redirect-info-confirm-access',
    loadChildren: () => import('./modules/bank-auth-redirect-info-confirm-access/bank-auth-redirect-info-confirm-access.module').then(m => m.BankAuthRedirectInfoConfirmAccessModule),
    resolve: {BanksResolver},
    canLoad: [checkIfFlowIdIsStoredGuard()],
    canActivate: [checkIfFlowIdIsStoredGuard()],
    canDeactivate: [deactivateGuard()]
  },
  {
    path: 'bank-auth-redirect-info-confirm-payment',
    loadChildren: () => import('./modules/bank-auth-redirect-info-confirm-payment/bank-auth-redirect-info-confirm-payment.module').then(m => m.BankAuthRedirectInfoConfirmPaymentModule),
    resolve: {BanksResolver},
    canLoad: [checkIfFlowIdIsStoredGuard()],
    canActivate: [checkIfFlowIdIsStoredGuard()],
    canDeactivate: [deactivateGuard()]
  },
  {
    path: 'redirect-info-account-selection',
    loadChildren: () => import('./modules/redirect-info-account-selection/redirect-info-account-selection.module').then(m => m.RedirectInfoAccountSelectionModule),
    canLoad: [checkIfFlowIdIsStoredGuard()],
    canActivate: [checkIfFlowIdIsStoredGuard()],
    canDeactivate: [deactivateGuard()]
  },
  {
    path: 'redirect-info-merchant',
    loadChildren: () => import('./modules/redirect-info-merchant/redirect-info-merchant.module').then(m => m.RedirectInfoMerchantModule),
    canLoad: [checkIfFlowIdIsStoredGuard()],
    canActivate: [checkIfFlowIdIsStoredGuard()],
    canDeactivate: [deactivateGuard()]
  },
  {
    path: 'account-selection',
    loadChildren: () => import('./modules/account-selection/account-selection.module').then(m => m.AccountSelectionModule),
    resolve: {AccountsResolver},
    canLoad: [checkIfFlowIdIsStoredGuard()],
    canActivate: [checkIfFlowIdIsStoredGuard()],
    canDeactivate: [deactivateGuard()]
  },
  {
    path: 'account-confirmation',
    loadChildren: () => import('./modules/account-confirmation/account-confirmation.module').then(m => m.AccountConfirmationModule),
    resolve: {BanksResolver, TransactionResolver},
    canLoad: [checkIfFlowIdIsStoredGuard()],
    canActivate: [checkIfFlowIdIsStoredGuard()],
    canDeactivate: [deactivateGuard()]
  },
  {
    path: 'error',
    loadChildren: () => import('./modules/error/error.module').then(m => m.ErrorModule),
    resolve: {errorInfo: ErrorResolver},
    canDeactivate: [deactivateGuard()]
  },
  {path: '**', redirectTo: 'error'}
];

@NgModule({
  imports: [RouterModule.forRoot(ROUTES, {preloadingStrategy: PreloadAllModules, canceledNavigationResolution: 'computed'})],
  declarations: [],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
